import { useFiltersQuery } from '@/domain/prices/filters/hooks';
import { usePrices } from '@/domain/prices/prices/hooks';
import { useRoomsQuery } from '@/domain/prices/rooms/hooks';
import { useTransportSelector } from '@/domain/prices/transports/hooks';
import { useDependencies } from '@/scopes/common/infrastructure/dependencies';
import { usePricesStoreSelector } from '@/infrastructure/prices/usePricesStore';
import { hasBookingDraftCreationSucceeded, isCreateBookingDraftLoading } from '@/domain/prices/bookingDraft/selectors';
import type { PriceTableAnalytics } from '@/scopes/prices/domain/types';

export const usePriceTableState = () => {
  const { isLoading: loadingFilters, isFetching: fetchingFilters } = useFiltersQuery();
  const { isFetching: fetchingPrices } = usePrices();
  const { isFetching: fetchingRooms } = useRoomsQuery();
  const { isFetching: fetchingTransport } = useTransportSelector();
  const isBookingDraftCreationPending = usePricesStoreSelector(isCreateBookingDraftLoading);
  const isBookingDraftCreationSuccess = usePricesStoreSelector(hasBookingDraftCreationSucceeded);

  const isLoading =
    loadingFilters ||
    fetchingFilters ||
    fetchingPrices ||
    fetchingRooms ||
    fetchingTransport ||
    isBookingDraftCreationPending ||
    isBookingDraftCreationSuccess;

  return {
    isLoading,
  };
};

export const useInitializePriceTable = () => {
  const { queryStringClient, pricesStore } = useDependencies();

  return {
    initialize: ({ analytics }: { analytics: PriceTableAnalytics | null }) => {
      const originList = queryStringClient.getValue('originList');
      analytics && pricesStore.getState().setIn('analytics', { ...analytics, originList: originList || undefined });
      if (!originList) return;
      queryStringClient.remove('originList');
    },
  };
};
